import React, { useEffect } from 'react';
import { TimerValusSet } from '../../context/TimerContext';
import { SessionExpirePopup } from './sessionExpirePopup';

const SessionTimer: React.FC<any> = () => {
  const { timeExit, userHeartBeat, setClosePopupConfirmation, closePopupConfirmation, showConfirmation, setShowConfirmation } = React.useContext(TimerValusSet);
  const [userTimerValue, setUserTimerValue] = React.useState<any>()

  useEffect(() => {
    setUserTimerValue(userHeartBeat)
  }, [userHeartBeat]);

  useEffect(() => {
    let interval: any;
    if (userTimerValue >= 0) {
      interval = setInterval(() => {
        if (userTimerValue <= 300 && !closePopupConfirmation) {
          setShowConfirmation(true);
          setClosePopupConfirmation(true);
        }
        setUserTimerValue((prevTime: number) => prevTime - 1);
      }, 1000);
    }
    else if (userTimerValue <= 0) {
      const timerValue = timeExit();
      if (timerValue < 300) {
        setShowConfirmation(true);
      } else {
        setShowConfirmation(false);
      }
    }
    return () => clearInterval(interval);
  }, [userTimerValue]);

  const onConfirmAction = (value: any) => {
    setShowConfirmation(false);
  };

  return (
    <>
      {showConfirmation && (
        <SessionExpirePopup
          expireTime={userTimerValue}
          openConfirmation={showConfirmation}
          closeConfirmation={onConfirmAction}
        />
      )}
    </>
  );
};

export default SessionTimer;